export enum ProgressState {
    NotLoaded,
    Loading,
    Loaded,
    Failed
}
